import React from "react";
import { motion } from "framer-motion";
import Button from "../common/Button";
import { CheckIcon } from "@heroicons/react/outline";

// Renamed from StepperModal to Stepper since it's no longer a modal
const Stepper = ({
  title,
  steps,
  currentStep,
  children,
  onNext,
  onPrevious,
  onSubmit,
  onCancel,
  loading,
}) => {
  const isLastStep = currentStep === steps.length;
  const isFirstStep = currentStep === 1;

  return (
    <div className="w-full bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <div className="p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-6">
          {title}
        </h3>

        {/* Stepper */}
        <div className="flex items-center justify-between mb-8">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;

            return (
              <React.Fragment key={step.label}>
                <div className="flex flex-col items-center">
                  <motion.div
                    initial={false}
                    animate={{
                      scale: isActive ? 1.1 : 1,
                      backgroundColor: isActive
                        ? "#6366f1"
                        : isCompleted
                        ? "#10b981"
                        : "#e5e7eb",
                    }}
                    transition={{ duration: 0.3 }}
                    className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold ${
                      isActive || isCompleted
                        ? ""
                        : "text-gray-600 dark:text-gray-400"
                    }`}
                  >
                    {isCompleted ? (
                      <CheckIcon className="w-5 h-5" />
                    ) : (
                      stepNumber
                    )}
                  </motion.div>
                  <span
                    className={`mt-2 text-sm ${
                      isActive
                        ? "text-primary font-semibold"
                        : isCompleted
                        ? "text-success"
                        : "text-gray-500 dark:text-gray-400"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`flex-1 h-0.5 mx-4 ${
                      isCompleted
                        ? "bg-success"
                        : "bg-gray-300 dark:bg-gray-600"
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Content */}
        <div className="min-h-[400px] mb-6">{children}</div>

        {/* Actions */}
        <div className="flex justify-between">
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={isFirstStep || loading}
          >
            Previous
          </Button>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={onCancel}>
              Cancel
            </Button>
            {isLastStep ? (
              <Button variant="primary" onClick={onSubmit} loading={loading}>
                Send Campaign
              </Button>
            ) : (
              <Button variant="primary" onClick={onNext}>
                Next
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
